import { useMedia } from '@stitch-fix/mode-react';
import { useEffect, useRef, useState } from 'react';

const SLIDE_DURATION = 2500;

export const useAutoAdvanceTimer = ({ totalItems }: { totalItems: number }) => {
  const prefersReducedMotion = useMedia('(prefers-reduced-motion)');
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const requestAnimationId = useRef<number>(0);

  useEffect(() => {
    const handleSlideAutoAdvance = () => {
      let start = performance.now();

      const tick = (timestamp: number) => {
        if (timestamp - start >= SLIDE_DURATION) {
          setShouldAnimate(true);
          setActiveSlideIndex(
            prevSlideIndex => (prevSlideIndex + 1) % totalItems,
          );
          start = timestamp;
        }
        requestAnimationId.current = requestAnimationFrame(tick);
      };

      requestAnimationId.current = requestAnimationFrame(tick);
    };

    if (!prefersReducedMotion && totalItems > 1) {
      handleSlideAutoAdvance();
    }

    return () => cancelAnimationFrame(requestAnimationId.current);
  }, [totalItems, prefersReducedMotion]);

  return {
    shouldAnimate,
    activeSlideIndex,
  };
};
